import React from "react";

/**
 * Alterna a lente da home: Semana (gestão do time) ou Mês (horas e dinheiro).
 *
 * O toggle é o mecanismo anti-entulho da tela: em vez de empilhar tudo numa página só, cada
 * cadência carrega apenas o que ela decide. Alertas ficam fora dele — risco não tem cadência.
 */

export type HomeView = "week" | "month";

interface Props {
  view: HomeView;
  onChange: (v: HomeView) => void;
}

const ViewToggle: React.FC<Props> = ({ view, onChange }) => (
  <div
    role="group"
    aria-label="Visão"
    className="inline-flex gap-1 rounded-full border border-gray-200 bg-white p-1 dark:border-white/10 dark:bg-navy-800"
  >
    {([
      { key: "week" as const, label: "Semana" },
      { key: "month" as const, label: "Mês" },
    ]).map((o) => (
      <button
        key={o.key}
        type="button"
        aria-pressed={view === o.key}
        onClick={() => onChange(o.key)}
        className={`rounded-full px-5 py-2 font-display text-xs font-bold tracking-wide transition-all ${
          view === o.key
            ? "bg-gradient-to-r from-dv-blue-500 to-dv-cyan-400 text-white shadow-dv-md"
            : "text-gray-600 hover:text-navy-700 dark:text-gray-300 dark:hover:text-white"
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export default ViewToggle;
